import {createSelector, Selector} from 'reselect';
import {UserConfigStateType} from 'module/UserConfig/reducer/UserConfigReducer';
import {UserConfigDefinitionType} from 'module/UserConfig/type/UserConfigType';
import _ from 'lodash';

export const userConfigStructure = {} as Record<string, Record<string, any>> // rendered in settings

export function initUserConfig(namespace: string, userConfig: UserConfigDefinitionType) {
	if (!userConfigStructure[namespace]) userConfigStructure[namespace] = {}
	_.forEach(userConfig, (member, key) => {
		userConfigStructure[namespace][key] = member
		//flatten userConfig -> all keys must be unique in one namespace
		if (member.userConfig) initUserConfig(namespace, member.userConfig)
	})
}

const keySelectors = {} as Record<string, Record<string, Selector<any, any>>>;
export const selUserConfigKeyGenerator = (namespace: string, key: string) => {
	if (!keySelectors[namespace]) keySelectors[namespace] = {}
	if (keySelectors[namespace][key]) return keySelectors[namespace][key]
	return keySelectors[namespace][key] = createSelector(
		(state: UserConfigStateType) => state.UserConfig[namespace] && state.UserConfig[namespace][key],
		(state: any) => userConfigStructure[namespace]?.[key]?.defaultOverrideSelector?.(state),
		(v, defaultValue) => {
			if (v !== undefined) return v
			if (defaultValue !== undefined) return defaultValue
			return userConfigStructure[namespace]?.[key]?.defaultValue
		},
	)
}

// use only for saving to ViewStore
export const selUserConfigFull = (state: UserConfigStateType) => state.UserConfig